import { Extensions } from "@tiptap/core";
import Link from "@tiptap/extension-link";
import { Youtube } from "@tiptap/extension-youtube";
import { StarterKit } from "@tiptap/starter-kit";

import { isMobileDevice } from "@/utils";

import { AI } from "./ai";
import { BookmarkExtension } from "./bookmark";
import { BubbleMenu } from "./bubbleMenu";
import { HighlightExtension, HighlightInteractionExtension } from "./highlight";
import { StepTocExtension } from "./tableOfContents";
import { UUIDExtension } from "./uuid";
import { WaffleMenuExtension } from "./waffleMenu";

type Options = {
  withNodeHover: boolean;
  hasBookmarksFeature: boolean;
};

export function createExtensions(instanceId: string, opts: Options) {
  const extensions: Extensions = [
    StarterKit.configure({
      code: false,
      codeBlock: false,
      dropcursor: false,
      gapcursor: false,
      listItem: false,
    }) as Extensions[number],
    Link.configure({ openOnClick: true, HTMLAttributes: { target: "_blank", style: "cursor: pointer;" } }),
    UUIDExtension.configure({
      attributeName: "node-id",
      types: [
        "nw-image",
        "paragraph",
        "heading",
        "bulletList",
        "orderedList",
        "listItem",
        "nw-checkbox",
        "blockquote",
        "codeBlock",
        "nw-step",
        "nw-section",
        "nw-validation-box",
        "nw-quiz",
        "nw-note",
      ],
      debug: false,
    }),
    AI,
    BubbleMenu.configure({
      element: document.createElement("nw-highlight-toolbar"),
    }),
    HighlightExtension,
    HighlightInteractionExtension,
    Youtube.configure({
      allowFullscreen: true,
      modestBranding: true,
      ivLoadPolicy: 3,
      playlist: "",
      HTMLAttributes: {
        style: "margin: 24px auto; border-radius: 12px;",
      },
    }),
  ];

  if (opts.withNodeHover && opts.hasBookmarksFeature) {
    if (!isMobileDevice()) {
      extensions.push(
        WaffleMenuExtension.configure({
          nodeTypes: [
            "paragraph",
            "listItem",
            "heading",
            "nw-image",
            "nw-validation-box",
            "blockquote",
            "codeBlock",
            "nw-checkbox",
            "nw-note",
          ],
          wrapperTags: ["nw-note", "blockquote", "nw-validation-box"],
        }),
      );
    }

    extensions.push(
      BookmarkExtension.configure({
        nodeTypes: [
          "paragraph",
          "listItem",
          "heading",
          "nw-image",
          "nw-validation-box",
          "blockquote",
          "codeBlock",
          "nw-checkbox",
          "nw-note",
        ],
      }),
    );
  }

  if (instanceId !== "intro") {
    extensions.push(StepTocExtension);
  }

  return extensions;
}
